<template>
  <v-list-tile class="c-post-list-tile" :class="{ closed: isClosed }" avatar @click="onClick">
    <v-list-tile-avatar class="c-avatar">
      <v-icon>{{ $utils.postCodeToIcon(post.type) }}</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title class="c-ttl"
        ><span v-if="cms">{{ title }}</span></v-list-tile-title
      >
      <v-list-tile-sub-title class="c-sub-ttl">
        <span>{{ content }}</span>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action class="c-chip">
      <div class="c-time">{{ fmtTime }}</div>
      <template v-if="['JI', 'JA', 'FI', 'FA'].indexOf(post.type) != -1">
        <post-avatar class="c-avt" :postId="post.id" :name="post.creator_cm_name" :pos="1" :elevation="1" />
      </template>
      <template v-else>
        <cmid-avatar class="c-avt" :cmid="post.creator_cmid" :cid="post.community_id" :pos="1" :elevation="1" />
      </template>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import postPlugin from '../../utils/plugin/postPlugin';
import UTILS from '../../utils/utils';

import postAvatar from '../../components/common/PostAvatar.vue';

export default {
  mixins: [postPlugin],
  components: {
    'post-avatar': postAvatar,
  },
  props: {
    post: { type: Object, required: true },
  },
  data() {
    return {
      badge: false,
      cms: null,
    };
  },
  mounted() {
    this.badge = !!this.unreadCount;
    this.resetCms(this.cid);
  },
  watch: {
    unreadCount(n, o) {
      this.badge = !!n;
    },
    cid(n, o) {
      if (n != o) {
        this.resetCms(n);
      }
    },
  },
  computed: {
    cid() {
      return this.post.community_id;
    },
    isClosed() {
      return UTILS.isPostCompleted(this.post);
    },
    title() {
      return this.postTitle(this.post);
    },
    content() {
      if (this.post.type == 'JA') return '';
      if (this.post.type == 'JI') return '';
      if (this.post.type == 'FA') return '';
      if (this.post.type == 'FI') return '';
      return this.post.content.main;
    },
    fmtTime() {
      return this.diffDateFormatShort(this.$moment.unix(this.post.post_at));
    },
  },
  methods: {
    onClick() {
      this.$emit('click', this.post);
    },
    resetCms(cid) {
      this.cms = null;
      var self = this;
      this.getAllGroupsAndMembers(cid, function(data) {
        self.cms = data.cms;
      });
    },
  },
};
</script>

<style scoped>
.c-post-list-tile.closed {
  background-color: rgba(0, 0, 0, 0.05);
}
.c-list {
  height: calc(100vh - 222px);
  overflow: scroll;
}
.le-tbs .c-list {
  height: calc(100vh - 156px);
}
.le-sp .c-list {
  height: initial !important;
  padding-bottom: 60px;
}
.c-post-list {
  padding: 0;
}
.le-tbs .c-post-list {
  padding-top: 48px;
}
.c-avatar {
  min-width: 55px;
  max-width: 55px;
  height: 100%;
  margin: 0 0 0 -5px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c-avatar i {
  font-size: 28px;
}
.c-div {
  margin-left: 65px;
  max-width: calc(100% - 65px);
}
.c-chip {
  max-width: 35px;
  min-width: 35px;
}
.c-chip .c-time {
  position: absolute;
  top: 2px;
  right: 8px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.c-avt {
  position: absolute;
  bottom: 5px;
  right: 12px;
  opacity: 0.9;
}
.c-ttl {
  font-size: 15px;
}
.c-sub-ttl {
  min-height: 15px;
  max-height: 30px;
  overflow-y: hidden !important;
  font-size: 12px !important;
  line-height: 15px;
  margin-top: 1px;
}
</style>
